const state = {
    tableLoading:false
};

export default {
    namespaced: true,
    state,
}


// WEBPACK FOOTER //
// ./src/store/modules/common/index.js